import getSlug from 'speakingurl';

/**
 * Turns a file name into the name an uploaded file is stored under, e.g.
 * `Tarkistuslista (1).docx` → `Tarkistuslista_1_.docx`. Letters keep their
 * case, letters outside plain ASCII are spelled out (`ä` → `ae`) and spaces
 * become `_`.
 */
const getSafeFilename = (filename: string): string =>
  getSlug(filename, {
    custom: { '~': '-', '(': '_', ')': '_', '!': '_', "'": '_' },
    maintainCase: true,
    mark: true,
    separator: '_'
  });

export default getSafeFilename;
